import React from 'react'
import { Modal } from 'react-bootstrap'
import i18next from 'i18next'

import Notificator from './Notificator'

export default class QuestionnaireError extends React.Component {
  render() {
    const { error } = this.props

    return (
      error && (
        <Modal show={true}>
          <Modal.Body style={{ backgroundColor: '#F3DFF1', borderRadius: 6 }}>
            <Notificator type="error">
              <h1>{i18next.t('oops')}</h1>

              <p>{i18next.t('something_went_wrong_please_refresh_page')}</p>

              <br />

              <p>
                <a
                  href="#"
                  onClick={e => {
                    window.location.reload()
                    e.preventDefault()
                  }}
                >
                  {i18next.t('refresh_the_page')}
                </a>
              </p>
            </Notificator>
          </Modal.Body>
        </Modal>
      )
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/QuestionnaireError.js